export interface CurrencyInterface {
  id?: string;
  short?: string;
  detailed?: string;
  sign?: string;
}
